<template>
<div class="settings-warehouse">
	<div class="settings-warehouse__wrapper">
		<div class="container">
			<!-- <settings-warehouse-header :breadcrumbs="breadcrumbs"  /> -->
			<div class="page-header">
				<h1 class="page-title">
					<router-link class="text" to="/settings">{{ $t('Settings') }}</router-link>
					<i class="separator material-icons">chevron_right</i>
					<span class="page-breadcrumb">{{ $t('Warehouse') }}</span>
				</h1>
			</div>
			<settings-warehouse-content />
		</div>
	</div>
</div>
</template>

<script>
// import SettingsWarehouseHeader from '@/components/setting/Warehouse/Headers.vue';
import SettingsWarehouseContent from '@/components/setting/Warehouse/Content.vue';

export default {
	name: 'SettingsWarehouse',
	props: {
		breadcrumbs: {
			type: Array,
			default: () => ([]),
		},
	},
	components: {
		// SettingsWarehouseHeader,
		SettingsWarehouseContent,
	},
};
</script>

<style lang="scss" scoped>
.settings-warehouse {
	&__wrapper {
		padding: 2em 0;
	}
}
</style>
